import { render, staticRenderFns } from "./back-btn-group.vue?vue&type=template&id=58752c67"
import script from "./back-btn-group.vue?vue&type=script&lang=js"
export * from "./back-btn-group.vue?vue&type=script&lang=js"
import style0 from "./back-btn-group.vue?vue&type=style&index=0&id=58752c67&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports